import './styles.scss';

import React, {PropsWithChildren} from 'react';

export enum AppSocialButtonEnum {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
}

interface AppSocialButtonProps extends PropsWithChildren {
    type: AppSocialButtonEnum;
    disabled?: boolean;
    onClick: () => void;
}

export const AppSocialButton = ({children, type, disabled, onClick}: AppSocialButtonProps) => {
    return (
        <button
            className={`app-social-button app-social-button_${type}`}
            disabled={disabled}
            onClick={onClick}>
            {children}
        </button>
    );
};
